import React from 'react'

import { useTheme } from "@mui/material"

export const GetIconColor = () =>  {
    const { palette } = useTheme();
    return ({
        default: palette.grey[500],
        black: palette.icon.main,
        primary: palette.primary.main,
        white: palette.common.white,
        error: palette.common.error,
    }) 
}